<div class="modal-content">
    <h2 mat-dialog-title class="font-text">ATENCIÓN</h2>
    <p class="font-text">Eliminando {{poisToDelete.length}} pois</p>

    <mat-dialog-actions>
        <button mat-button (click)="noDelete()" class="font-text">Cancelar</button>
        <button mat-button (click)= "handleSelected()" class="font-text">Borrar</button>
    </mat-dialog-actions>
</div>